import { gql } from '@apollo/client';

export interface DeleteReplayManualVersionResponse {
    deleteReplayManualVersion: boolean;
}

export interface DeleteReplayManualVersionVariables {
    versionId: number;
}

export const DELETE_REPLAY_MANUAL_VERSION = gql`
    mutation DeleteReplayManualVersion($versionId: Long!) {
        deleteReplayManualVersion(versionId: $versionId)
    }
`;
